(() => {
  const normalize = text => text.toLocaleLowerCase('pl').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ł/g, 'l').trim();
  document.querySelectorAll('.ecatalog').forEach(section => {
    const input = section.querySelector('input[type="search"]');
    const cards = [...section.querySelectorAll('.bs__card')];
    const count = section.querySelector('.ecatalog__count');
    const initialCount = count.textContent;
    section.querySelector('.ecatalog__search-panel').hidden = false;
    input.addEventListener('input', () => {
      const query = normalize(input.value);
      let matches = 0;
      cards.forEach(card => {
        card.hidden = !normalize(card.querySelector('h3').textContent).includes(query);
        if (!card.hidden) matches++;
      });
      count.textContent = query ? `Znaleziono: ${matches}` : initialCount;
      section.querySelector('.ecatalog__no-results').hidden = !query || matches > 0;
      const pagination = section.querySelector('.ecatalog__pagination');
      if (pagination) pagination.hidden = !!query;
    });
    const form = section.querySelector('.ecatalog__sort');
    const select = form.querySelector('select');
    const navigate = value => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      url.searchParams.delete('page');
      window.location.assign(url.href);
    };
    select.addEventListener('change', () => navigate(select.value));
    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'ecatalog__sort-trigger';
    trigger.setAttribute('aria-haspopup', 'menu');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.textContent = `Sortuj: ${select.selectedOptions[0].textContent}`;
    const menu = document.createElement('div');
    menu.className = 'ecatalog__sort-menu';
    menu.id = `${select.id}-menu`;
    menu.hidden = true;
    menu.setAttribute('role', 'menu');
    menu.setAttribute('aria-label', 'Sortowanie produktów');
    trigger.setAttribute('aria-controls', menu.id);
    const options = [...select.options].map(option => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ecatalog__sort-option';
      button.textContent = option.textContent;
      button.setAttribute('role', 'menuitemradio');
      button.setAttribute('aria-checked', String(option.selected));
      button.tabIndex = -1;
      button.addEventListener('click', () => navigate(option.value));
      menu.append(button);
      return button;
    });
    const close = returnFocus => {
      menu.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      if (returnFocus) trigger.focus();
    };
    const open = () => {
      const rect = form.getBoundingClientRect();
      const below = window.innerHeight - rect.bottom - 20;
      const above = rect.top - 20;
      const upward = below < 200 && above > below;
      menu.classList.toggle('ecatalog__sort-menu--up', upward);
      menu.style.maxHeight = `${Math.max(100, Math.min(360, upward ? above : below))}px`;
      menu.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      options[select.selectedIndex].focus();
    };
    trigger.addEventListener('click', () => menu.hidden ? open() : close(false));
    trigger.addEventListener('keydown', event => {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') { event.preventDefault(); open(); }
    });
    menu.addEventListener('keydown', event => {
      const index = options.indexOf(document.activeElement);
      let next;
      if (event.key === 'ArrowDown') next = (index + 1) % options.length;
      if (event.key === 'ArrowUp') next = (index - 1 + options.length) % options.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = options.length - 1;
      if (next !== undefined) { event.preventDefault(); options[next].focus(); }
      if (event.key === 'Escape') { event.preventDefault(); close(true); }
      if (event.key === 'Tab') close(true);
    });
    document.addEventListener('click', event => { if (!form.contains(event.target)) close(false); });
    form.addEventListener('focusout', event => { if (!form.contains(event.relatedTarget)) close(false); });
    form.querySelector('label').hidden = true;
    select.hidden = true;
    form.classList.add('ecatalog__sort--custom');
    form.append(trigger, menu);
  });
})();
